type Variant = 'sage' | 'rose' | 'ink' | 'auto';
type Size = 'sm' | 'md' | 'lg';

type Props = {
  initials: string;
  size?: Size;
  variant?: Variant;
};

const variantBg: Record<Exclude<Variant, 'auto'>, string> = {
  sage: 'bg-gradient-to-br from-sage-300 to-sage-700',
  rose: 'bg-gradient-to-br from-rose-300 to-rose-500',
  ink:  'bg-gradient-to-br from-ink-300 to-ink-700',
};

const sizeClasses: Record<Size, string> = {
  sm: 'w-7 h-7 text-[11px]',
  md: 'w-9 h-9 text-xs',
  lg: 'w-11 h-11 text-sm',
};

function pickVariant(initials: string): Exclude<Variant, 'auto'> {
  const palette: Array<Exclude<Variant, 'auto'>> = ['sage', 'rose', 'ink'];
  const hash = initials
    .split('')
    .reduce((sum, ch) => sum + ch.charCodeAt(0), 0);
  return palette[hash % palette.length];
}

export default function Avatar({ initials, size = 'md', variant = 'auto' }: Props) {
  const v = variant === 'auto' ? pickVariant(initials) : variant;
  const safeInitials = initials.slice(0, 2).toUpperCase();
  return (
    <span className={`inline-flex items-center justify-center text-cream-50 font-semibold rounded-full ${sizeClasses[size]} ${variantBg[v]}`}>
      {safeInitials}
    </span>
  );
}
